const enum SeriesType {
  Line = "line",
  Bar = "bar",
}

export default SeriesType;
